import { IBridgeParams } from '../interface'

/**
 * 格式化桥接方法入参
 * @param providerName
 * @param funType
 * @param funName
 * @param opts
 */
function formatParams({
  providerName = 'isee',
  funType = '',
  funName = '',
  ...opts
}: IBridgeParams) {
  return {
    provider: {
      providerName
    },
    funType,
    funName,
    ...opts
  }
}

export default formatParams
